import { useMemo } from 'react';

import type { TWorkplaceFormFields } from 'entities/creditForm';

import { AccordionHeaderParamsTexts } from './AccordionHeaderParams.texts';
import { formatWorkplaceDescription } from './formatWorkplaceDescription';
import { formatWorkplaceTitle } from './formatWorkplaceTitle';

type THeaderParams = {
  title: string;
  icon: string;
  description: string;
};

type DefaultParams = Partial<Pick<THeaderParams, 'title' | 'description'>>;

export const useAccordionHeaderParams = (
  data: Nullable<TWorkplaceFormFields>,
  defaultData: DefaultParams,
  isOpen: boolean,
  isHideAccordionData = false,
) => {
  const {
    title = defaultData.title || AccordionHeaderParamsTexts.HeaderDefaultTitle,
    description = defaultData.description || AccordionHeaderParamsTexts.HeaderDefaultDescription,
  } = useMemo((): Partial<THeaderParams> => {
    if (!data || isOpen) {
      return {};
    }

    return {
      title: formatWorkplaceTitle(data, isHideAccordionData),
      description: formatWorkplaceDescription(data, isHideAccordionData),
    };
  }, [data, isOpen, isHideAccordionData]);

  return [title, description] as const;
};
